import { LoginCredentials, LoginResponse } from '../services/auth.service';
import { User } from '../models/core.models';
import { createAction, props } from '@ngrx/store';

export const login = createAction(
  '[User] Login',
  props<{ credentials: LoginCredentials }>(),
);

export const loginSuccess = createAction(
  '[User] Login Success',
  props<{ response: LoginResponse; remember: boolean }>(),
);

export const loginFailure = createAction(
  '[User] Login Failure',
  props<{ error: string }>(),
);

export const logout = createAction('[Auth] Logout');

export const authCheck = createAction('[Auth] Auth Check');

export const switchUserCompany = createAction(
  '[User] Switch User Company',
  props<{ companyId: string }>(),
);

export const switchUserCompanySuccess = createAction(
  '[User] Switch User Company Success',
  props<{ user: User }>(),
);

export const remoteLogin = createAction(
  '[User] Remote Login',
  props<{ token: string }>(),
);

export const remoteLoginSuccess = createAction(
  '[User] Remote Login Success',
  props<{ response: any }>(),
);

export const remoteLoginFail = createAction(
  '[User] Remote Login Fail',
  props<{ error: string }>(),
);

export const setRedirectUrl = createAction(
  '[User] Set Redirect Url',
  props<{ url: string }>(),
);

/**
 * Broadcast only, no effect behind it: `auth.reducer` patches the user; the
 * workspace and recent-object invalidations live with the toggle's owner in
 * `dropdown-user.component`.
 */
export const listCompanyObjectsSuccess = createAction(
  '[User] List Company Objects Success',
  props<{ listCompanyObjects: boolean }>(),
);
